import { AbstractControl } from '@angular/forms'

export function phoneValidator(
    c: AbstractControl
): { [key: string]: boolean } | null {
    const pattern = /^d+$/;
    if (!pattern.test(c.value)) {
        return {
            'app': false
        };
    }
}

// export class EqualValidator implements Validator {
//     constructor(@Attribute('validateEqual') public validateEqual: string) { }

//     validate(c: AbstractControl): { [key: string]: any } {
//         // self value (e.g. retype password)
//         let v = c.value;

//         // control value (e.g. password)
//         let e = c.root.get(this.validateEqual);

//         // value not equal
//         if (e && v !== e.value) return {
//             validateEqual: false
//         }
//         return null;
//     }
// }
